import React from 'react'

function toBool(value) {
    if (value === true || value === 'true' || value === 1 || value === '1') return true
    if (value === false || value === 'false' || value === 0 || value === '0') return false
    return null
}

/** Read-only table cell: check for true, cross for false, em dash when unset. */
class TableCheckboxBoolean extends React.Component {
    render() {
        const v = toBool(this.props.data)
        const isTrue = v === true
        const isFalse = v === false

        return (
            <div
                className="w-100 d-flex align-items-center justify-content-center"
                style={{ minHeight: 28, padding: '2px 0' }}
                aria-label={isTrue ? 'true' : isFalse ? 'false' : 'unset'}
            >
                {isTrue && (
                    <span style={{ color: '#059669', fontSize: 16, fontWeight: 800, lineHeight: 1 }} title="✓">
                        ✓
                    </span>
                )}
                {isFalse && (
                    <span style={{ color: '#dc2626', fontSize: 16, fontWeight: 700, lineHeight: 1 }} title="✕">
                        ✕
                    </span>
                )}
                {v === null && (
                    <span style={{ color: '#cbd5e1', fontSize: 13, fontWeight: 500, lineHeight: 1 }} title="—">
                        —
                    </span>
                )}
            </div>
        )
    }
}

export default TableCheckboxBoolean
